// ABOUTME: Placeholder for a form that is still loading — label + field rows in the real shape.
// ABOUTME: What a tab shows instead of a spinner while the page's top bar runs (DESIGN_SYSTEM.md §4.3).

import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { cn } from "@shared/lib/utils"

interface CFormSkeletonProps {
  /** How many label + field pairs to draw. */
  rows?: number
  className?: string
}

export const CFormSkeleton: FC<CFormSkeletonProps> = ({ rows = 4, className }) => {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      aria-label={t("common.loading")}
      className={cn("flex animate-pulse flex-col gap-5", className)}
    >
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className="flex flex-col gap-1.5"
        >
          <span className="h-3 w-32 rounded-md bg-secondary" />
          <span className="h-9 w-full max-w-100 rounded-lg bg-muted" />
        </div>
      ))}
    </div>
  )
}
